import { Button } from '@ipfabric/ui-components/Button/Button';
import type { TableActionsItem } from 'components/Table/model/TableModel';

/** The "Add new" table header button used by the admin policy and role tables. */
export const addNewMenuItem = (
  dataTestId: string,
  onClick: () => void,
): TableActionsItem => ({
  standalone: true,
  elementWithKey: (
    <Button
      dataTestId={dataTestId}
      key='addNew'
      icon='fa-plus-circle'
      onClick={onClick}
      size='small'
      type='button'
      variant='outline'
    >
      Add new
    </Button>
  ),
});
